/**
 * Affichage Super Admin — statut métier des comptes clients importés.
 */

export function isImportedPendingClient(client) {
  return client?.passwordSetupRequired === true;
}

export function formatPasswordSetupCompletedAt(value) {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString('fr-FR');
}

/**
 * Libellé statut métier (liste Clients SA).
 * « À activer » = importé non repris (passwordSetupRequired),
 * distinct de User.statut EN_ATTENTE (email non vérifié V2).
 */
export function getClientAccountStatusLabel(client) {
  if (isImportedPendingClient(client)) {
    return 'À activer';
  }
  if (client?.statut === 'INACTIF') {
    return 'INACTIF';
  }
  if (client?.statut === 'SUSPENDU') {
    return 'SUSPENDU';
  }
  if (client?.statut === 'EN_ATTENTE') {
    return 'EN_ATTENTE';
  }
  return 'Actif';
}

export function getClientAccountStatusTone(client) {
  if (isImportedPendingClient(client)) {
    return 'bg-amber-100 text-amber-800';
  }
  switch (client?.statut) {
    case 'ACTIF':
      return 'bg-green-100 text-green-800';
    case 'INACTIF':
      return 'bg-red-100 text-red-800';
    case 'SUSPENDU':
      return 'bg-yellow-100 text-yellow-800';
    case 'EN_ATTENTE':
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-green-100 text-green-800';
  }
}

/**
 * Params GET /users pour le filtre liste SA.
 * @param {string} listStatut
 * @param {number|{ page?: number, pageSize?: number, search?: string }} [pageSizeOrOpts]
 */
export function buildClientsListQueryParams(listStatut, pageSizeOrOpts = 100) {
  const opts =
    pageSizeOrOpts != null && typeof pageSizeOrOpts === 'object'
      ? pageSizeOrOpts
      : { pageSize: pageSizeOrOpts };
  const pageSize = opts.pageSize ?? 100;
  const base = { pageSize };
  if (opts.page != null) base.page = opts.page;
  if (opts.search) base.search = String(opts.search).trim();

  switch (listStatut) {
    case 'ALL':
      return base;
    case 'TO_ACTIVATE':
      return { ...base, passwordSetupRequired: true };
    case 'INACTIF':
      return { ...base, statut: 'INACTIF' };
    case 'ACTIF':
    default:
      // Actifs utilisables : pas les imports encore à activer
      return { ...base, statut: 'ACTIF', passwordSetupRequired: false };
  }
}
